module.exports = __webpack_public_path__ + "img/joy_vapaeetokens.4ab0086.png";